import { Component, OnInit } from '@angular/core';
import {AuthService} from '../services/auth.service'
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import{ApplicationService} from '../services/application.service'
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  loginUserData = {}
  username: string;
  password: string;
  constructor(private _authenticationService: AuthService,private router: Router,private _applicationService:ApplicationService) { }

  ngOnInit() {
  }  

   // This method used for admin login
   loginUser(loginForm: NgForm) {
     debugger   
    //this.loading = true;    
    this._authenticationService.partnerLogin(loginForm.value.username, loginForm.value.password,loginForm.value.usertype)
      .subscribe(
        data => {                  
          if (data.returnCode == 0) {   
            debugger                                  
            localStorage.setItem('currentUser', JSON.stringify({ token: data.responsetoken, userDetail: data.response.userDetail,isAdmin:loginForm.value.usertype ==='a'? true: false }));                
            let loginUser = JSON.parse(localStorage.getItem('currentUser'));    
           console.log(loginUser)
            if (loginUser) {
              if(loginForm.value.usertype == 'a')              {
                this._applicationService.loginUserDetails.userid = loginUser.userDetail.id;
                this._applicationService.loginUserDetails.token = loginUser.token;
                this._applicationService.loginUserDetails.name = loginUser.userDetail.name;
                this._applicationService.loginUserDetails.isAdmin=true;
                this._applicationService.loginUserDetails.profileImage=loginUser.userDetail.profileImage;
                this._applicationService.loginUserDetails.partnertypeId= "-1";
                this._applicationService.loginUserDetails.partnertype= "Administrator";
              }
              else{
                this._applicationService.loginUserDetails.userid = loginUser.userDetail.partnerId;
                this._applicationService.loginUserDetails.token = loginUser.token;
                this._applicationService.loginUserDetails.name = loginUser.userDetail.partnerName;
                this._applicationService.loginUserDetails.isAdmin=false;
                this._applicationService.loginUserDetails.profileImage=loginUser.userDetail.partnerProfileImage;
                this._applicationService.loginUserDetails.partnertypeId= loginUser.userDetail.partnertypeid;
                this._applicationService.loginUserDetails.partnertype=  loginUser.userDetail.partnerType;
               
              }
             
            }
            if(this._applicationService.loginUserDetails){
            this.router.navigate(['dashboard']);
           }
           else{
            this.router.navigate(['login']);
           }
            
            
          }
          else{
            console.log(data)
            alert(data.returnMsg)
          }
        },
        error => {
          // this.alertService.error(error);
          // this.loading = false;         
          alert(error)
          console.log(error)
        });
  }

}
